// extracted by mini-css-extract-plugin
export default {"preloader":"styles_preloader__C9kxt","spinner":"styles_spinner__vbfjl","spin":"styles_spin__qvivu"};